import { useState } from 'react';

import { usePersonService } from '@/services/person.service';
import helpers, { sendTagChain } from '@/utils/helpers';
import history from '@/utils/history';
import url from '@/utils/url'

export const useValidatePerson = (documentType, documentNumber, nClientStep) => {
  const isVE = helpers.validateVidaEndosable();
  const [attempts, setAttempts] = useState(0);
  const [showModalInvalidData, setShowModalInvalidData] = useState(false);

  const { validatePersonData } = usePersonService();

  const setActionsPostResponse = (personOrigin, percentageValidation) => {
    helpers.getTrackBDU(
      'Origen validación Cliente nuevo - Seguro Vida Devolución Garantizada',
      personOrigin,
      {
        documentType,
        documentNumber,
      },
      percentageValidation
    );
    const totalAttempts = attempts + 1;
    if (totalAttempts >= 3) {
      const message = "Usuario con datos incorrectos DNI";
      if (isVE) {
        sendTagChain([
          {
            type: "getTagError",
            code: "ErrorVidaEndosable",
            message
          },
          {
            type: "trackMetadata",
            key: "Endpoint",
            value: url.validarTercero
          }
        ])
      } else {
        helpers.getTagLog(message, "trackLog");
      }
      return history.push(nClientStep);
    } else if (totalAttempts > 0) {
      helpers.getTagLog("Datos incorrectos", "trackLog");
    }
    setAttempts(totalAttempts);
    setShowModalInvalidData(true);
  };

  const validatePerson = async (data) => {
    let validateStatus = '';
    let fieldsWithError = [];
    let personOrigin = '';
    let percentageValidation = '';

    try {
      const request = {
        tipoDocumento: String(documentType),
        numeroDocumento: String(documentNumber),
        nombres: data.names.trim(),
        apepat: data.lastName.trim(),
        apemat: data.surName.trim(),
        fecnac: data.birthdate,
        sexo: data.gender,
        canal: 'veh',
      };
      const response = await validatePersonData(request);
      const { resultinterpretacion, resultinputref } = response;

      const { estado, camposcorregidos, fuentereferencia } = resultinterpretacion;
      const { porcentajeaprox } = resultinputref;
      validateStatus = estado;
      fieldsWithError = camposcorregidos;
      personOrigin = fuentereferencia;
      percentageValidation = porcentajeaprox;
    } catch (error) {
      validateStatus = 'RECHAZADO';
      fieldsWithError = [];
      personOrigin = 'NE';
      percentageValidation = '-1';
    }

    if (validateStatus === 'RECHAZADO') {
      setActionsPostResponse(personOrigin, percentageValidation);
    }

    return { fieldsWithError, validateStatus };
  }

  return {
    validatePerson,
    showModalInvalidData,
    setShowModalInvalidData,
    resetAttempts: () => setAttempts(0),
  };

};